import { defineComponent as _defineComponent } from 'vue'
import { IconPlay } from '@/components/icons';

export default /*#__PURE__*/_defineComponent({
  __name: 'TG4PlayIcon',
  setup(__props) {



return { __sfc: true,IconPlay }
}

})